module.exports = __webpack_public_path__ + "static/media/9-iron.81b6ae7f.png";